import { Image, Space, Typography } from 'antd'
import { pathify } from 'shared'
import { useSingleReportsContext } from '../SingleReportsContext'

const ReportSample: React.FC = () => {
  const { report } = useSingleReportsContext()
  return (
    <Space align="start" direction="vertical">
      <Typography.Paragraph strong>Example Report</Typography.Paragraph>
      {!!report ? (
        <Image
          src={
            report?.sampleFilename
              ? `${process.env.REACT_APP_BACK_END_URL}${pathify(
                  'samples',
                  `${report.sampleFilename}.png`
                )}`
              : undefined
          }
          width={500}
          alt={`sample ${report?.name}`}
        />
      ) : (
        <Typography.Paragraph>
          Select a report to see an example
        </Typography.Paragraph>
      )}
    </Space>
  )
}

export default ReportSample
